import { ICommand } from "./ICommand";

export interface ICommandFactory<T, TCommand extends ICommand<T> = ICommand<T>> {
  createCommand(): TCommand;
}

export function instanceOfICommandFactory<T, TCommand extends ICommand<T>>(instance: any): instance is ICommandFactory<T, TCommand> {
  return instance
      && (instance.createCommand !== undefined);
}
